import { render, staticRenderFns } from "./index.vue?vue&type=template&id=799be636&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=799be636&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799be636",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppShopButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppShopButton.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default})
